import React, { FC } from 'react';

interface Icon {
  className: string;
}

const IconComponent: FC<Icon> = ({ className }) => <i className={className} aria-hidden="true" />;

export default IconComponent;
